var AUDIO_FORMAT = 'AUDIO';
var VIDEO_PORTRAIT_FORMAT = 'PORTRAIT';
var VIDEO_LANDSCAPE_FORMAT = 'LANDSCAPE';
export var CREATIVE_FORMAT = {
  AUDIO_FORMAT: AUDIO_FORMAT,
  VIDEO_PORTRAIT_FORMAT: VIDEO_PORTRAIT_FORMAT,
  VIDEO_LANDSCAPE_FORMAT: VIDEO_LANDSCAPE_FORMAT
};
export var ASPECT_RATIOS = {
  LANDSCAPE: 1.778,
  PORTRAIT: 0.5625,
  SQUARE: 1,
  UNKNOWN: -1
};